import { EVENTS_ROUTER_ROOT, EVENTS_ROUTER_EDIT, EVENTS_ROUTER_NEW } from './constants';
import EventsList from './EventsList';
import EventsNew from './EventsNew';
import EventsEdit from './EventsEdit';

const settings = {
  router: [
    {
      path: EVENTS_ROUTER_ROOT,
      component: EventsList
    },
    {
      path: EVENTS_ROUTER_NEW,
      component: EventsNew
    },
    {
      path: EVENTS_ROUTER_EDIT,
      component: EventsEdit
    }
  ]
};

export default settings;



// WEBPACK FOOTER //
// ./src/components/Events/index.js